import React from 'react';
function Payments({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="m5.156 10.813 14.032-5.125M16.593 8.75 18 8.25M5.219 11.063 4.53 9.155a.75.75 0 0 1 .438-.968l12.687-4.594a.75.75 0 0 1 .969.437l2.719 7.5a.75.75 0 0 1-.438.969l-3.281 1.188v-1.825a.8.8 0 0 0-.234-.566v0a.8.8 0 0 0-.566-.235H5.219Z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M16.875 11.063h-13.5a.75.75 0 0 0-.75.75v7.874c0 .415.336.75.75.75h13.5a.75.75 0 0 0 .75-.75v-7.875a.75.75 0 0 0-.75-.75ZM14.5 17.938h.625m-10-2.5H9.5 5.125Zm8.125-1.876h1.875-1.875Zm-8.125 4.376h.625-.625Zm3.125 0h.625-.625Zm3.125 0H12h-.625Z"
      />
    </svg>
  );
}

export default Payments;
